export default "<ion-content>\n  <app-upgrade-form>\n    <span>Platinum</span>\n  </app-upgrade-form>\n</ion-content>\n"